import { render, staticRenderFns } from "./InTouch.vue?vue&type=template&id=dd43f80a&"
import script from "./InTouch.vue?vue&type=script&lang=js&"
export * from "./InTouch.vue?vue&type=script&lang=js&"
import style0 from "./InTouch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports